import { ReactNode } from "react";
import { Audience, AudienceFilterType, AudienceGroupFilter } from "../interfaces/Campaign.interface";
import { Tag as ITag} from "../interfaces/Tag.interface";
import { Button, Tag, Typography } from "antd";
import { jsxJoin } from "./jsx.join.utils";
import { DownloadOutlined } from "@ant-design/icons";

const tagForFieldName = (fieldName:string, tags:ITag[]): ITag|undefined => {
    return tags.find(t=>t.name == fieldName);
}

const getAllowedLabel = (fieldName:string, value:string, tags:ITag[]):string =>{
    let tag = tagForFieldName(fieldName, tags);
    if(tag && tag.meta.allowedValues)
    {
        
        let lookupKV = tag.meta.allowedValues.find(x=>x.value == value);
        if(lookupKV)
        {
            return lookupKV.label ?? value;
        }

    }
    return value;

}
const filterToHumanReadableString = (applicationId:string,filter:AudienceGroupFilter, tags:ITag[], onDownload:(applicationId:string, fileId?:string, fileName?:string)=>void):ReactNode => {
    let tag = tagForFieldName(filter.fieldName, tags);
    let node:ReactNode = `'${tag?.label ?? filter.fieldName}'`
    switch(filter.type)
    {
        case AudienceFilterType.STR_EQUALS:
        case AudienceFilterType.NUM_EQUAL_TO:
            node = `${node} = '${filter.string_value ?? filter.num_value}'`
            break;
        case AudienceFilterType.STR_STARTS_WITH:
            node = `${node} Starts With '${filter.string_value}'`
            break;
        case AudienceFilterType.STR_ENDS_WITH:
            node = `${node} Ends With '${filter.string_value}'`
            break;
        case AudienceFilterType.STR_CONTAINS:
            node = `${node} Contains '${filter.string_value}'`
            break;
        case AudienceFilterType.STR_DOES_NOT_EQUAL:
            node = `${node} NOT '${filter.string_value}'`
            break;
        case AudienceFilterType.STR_IS_ONE_OF:
            if(filter.fileId)
            {
                node = (<>{node} IN {"( "}{<Button icon={<DownloadOutlined />} onClick={()=>onDownload(applicationId, filter.file.id, filter.file.fileName)} title={filter.file.fileName}>{filter.file.fileName}</Button>}{" )"}</>)
            } else {
                let isOneOfStringValue:string = filter?.string_value + '';
                node = (<>{node} IN {"( "}{isOneOfStringValue.split(',').map(x=>(<Tag key={x}>{getAllowedLabel(filter.fieldName,x, tags)}</Tag>))}{" )"}</>)
            }
            break;
        case AudienceFilterType.STR_IS_NOT_ONE_OF:
            let isNotOneOfStringValue:string = filter?.string_value + '';
            node = (<>{node} IN {"( "}{isNotOneOfStringValue.split(',').map(x=>(<Tag key={x}>{getAllowedLabel(filter.fieldName,x, tags)}</Tag>))}{" )"}</>)
            break;
        case AudienceFilterType.NUM_NOT_EQUAL_TO:
            node = `${node} != ${filter.num_value}`
            break;
        case AudienceFilterType.NUM_GREATER_THAN:
            node = `${node} > ${filter.num_value}`
            break;
        case AudienceFilterType.NUM_GREATER_THAN_OR_EQUAL_TO:
            node = `${node} >= ${filter.num_value}`
            break;
        case AudienceFilterType.NUM_LESS_THAN:
            node = `${node} < ${filter.num_value}`
            break;
        case AudienceFilterType.NUM_LESS_THAN_OR_EQUAL:
            node = `${node} <= ${filter.num_value}`
            break;
        case AudienceFilterType.BOOL_IS_TRUE:
            node = `${node} is True`
            break;
        case AudienceFilterType.BOOL_IS_FALSE:
            node = `${node} is False`
            break;
    }
    return node;
}
export const audienceToHumanReadableString = (applicationId:string, audience:Audience, tags:ITag[], onDownload:(applicationId:string, audienceId?:string, fileId?:string, fileName?:string)=>void):ReactNode => {
    return jsxJoin(audience.audienceGroups.map(group=>{
        return jsxJoin(group.filters.map(filter=>filterToHumanReadableString(applicationId, filter, tags, (applicationId, fileId, fileName)=>{ onDownload(applicationId, audience.id, fileId, fileName)})),` ${group.type} `);
    }), ` OR `, ["{ "," }"]);
}